import { render, staticRenderFns } from "./IconAppleHealth.vue?vue&type=template&id=2dd66c5d&scoped=true"
import script from "./IconAppleHealth.vue?vue&type=script&lang=js"
export * from "./IconAppleHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd66c5d",
  null
  
)

export default component.exports